module.exports = __webpack_public_path__ + "static/media/smirking-emoji-svgrepo-com.5f4f1475.svg";